import type {
  GenderValues,
  ProfileValues,
} from '@/src/features/auth/validation';
import type {
  ProfileGender,
  ProfileGenderValue,
} from '@/src/features/profile/profile-service';

export const genderOptions: { label: string; value: ProfileGenderValue }[] = [
  { label: 'Female', value: 'female' },
  { label: 'Male', value: 'male' },
];

export function genderValueToFormValue(
  value: ProfileGenderValue | null | undefined,
): GenderValues {
  if (value !== 'female' && value !== 'male') {
    return emptyGenderFormValue();
  }

  return { value, customText: null };
}

export function emptyGenderFormValue(): GenderValues {
  return { value: '' as ProfileGenderValue, customText: null };
}

export function profileGenderToFormValue(
  gender: ProfileGender | null | undefined,
) {
  return genderValueToFormValue(gender?.value);
}

export function defaultProfileFormValues(): ProfileValues {
  return {
    bio: null,
    fullName: '',
    gender: emptyGenderFormValue(),
    location: null,
  };
}
